const defaultSteelClass = {
    name: 'S355',
    fyk: 355
};

export default defaultSteelClass;